import { Component, EventEmitter, inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DropdownChangeEvent } from 'primeng/dropdown';
import { Catalog } from 'src/app/shared/models/echo/catalog';
import { AutoCompleteCompleteEvent, AutoCompleteDropdownClickEvent, AutoCompleteOnSelectEvent } from 'primeng/autocomplete';
import { SetupLogicService } from 'src/app/shared/services/setup.logic.service';
import { Molecule } from 'src/app/shared/models/echo/molecule';

@Component({
  selector: 'app-ef-setup-inputs',
  templateUrl: './ef-setup-inputs.component.html',
  styleUrls: ['./ef-setup-inputs.component.css']
})
export class EFSetupInputsComponent implements OnChanges {

  @Input() geographies: Catalog[] = [];
  @Input() currentUserName: string = "";
  @Input() activeIngredients: Molecule[] = [];

  createdBy: string = "";
  selectedGeography?: Catalog;
  selectedActiveIngredient?: Molecule;

  @Output() onActiveIngredientSelectionChangeEvent = new EventEmitter<Molecule>();
  @Output() onQueryFilterChangeEvent = new EventEmitter<string>();
  @Output() isSetupValidEvent = new EventEmitter<boolean>();
  @Output() onGeographySelectionChangeEvent = new EventEmitter<Catalog | undefined>();

  loadingGeographies: boolean = true;
  isActiveIngredientValid: boolean = true;
  isGeographyValid: boolean = true;

  private setupLogicService = inject(SetupLogicService);

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentUserName']) {
      this.createdBy = this.currentUserName;
    }
    this.loadingGeographies = changes['geographies']?.currentValue?.length == 0;
  }

  onQueryFilterEvent({ query }: AutoCompleteCompleteEvent) {
    this.onQueryFilterChangeEvent.emit(query);
  }

  activeIngredientSelectionChanged({ value }: AutoCompleteOnSelectEvent) {
    this.selectedActiveIngredient = value;
    this.isActiveIngredientValid = value != null;
    this.onActiveIngredientSelectionChangeEvent.emit(value);
    this.validateSetup();
  }

  activeIngredientOnClear(event: any) {
    this.selectedActiveIngredient = undefined;
    this.isActiveIngredientValid = false;
    this.onActiveIngredientSelectionChangeEvent.emit(undefined);
    this.validateSetup();
  }

  activeIngredientDropdownClicked({ query }: AutoCompleteDropdownClickEvent) {
    this.onQueryFilterChangeEvent.emit(query ?? '');
  }

  geographySelectionChanged({ value }: DropdownChangeEvent) {
    this.selectedGeography = value;
    this.isGeographyValid = value != null;
    this.setupLogicService.selectedGeographyKey.set(value);
    this.onGeographySelectionChangeEvent.emit(value);
    this.validateSetup();
  }

  validateSetup() {
    const isValid = this.selectedActiveIngredient != null && this.selectedGeography != null;
    this.isSetupValidEvent.emit(isValid);
  }
}
